import React from "react";
import { Outlet } from "react-router-dom";
import UserHeader from "../UserHeader/UserHeader";
import BottomNavbar from "../BottomNavbar/BottomNavbar";
import "./UserLayout.css";

const UserLayout = () => {
  return (
    <div className="user-layout-container">
      <UserHeader />
      <main className="user-page-content">
        <Outlet />
      </main>
      <BottomNavbar />
    </div>
  );
};

export default UserLayout;
